import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Input,
  Button,
  Label,
  FormGroup,
  Table,
  Media,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createSelector } from "reselect";
import { components } from "react-select";
import {
  createBrand,
  getBrandCategory,
  getBrandThunk,
} from "../../../../live-slices/brands/thunk";
import sampleimage from "../../../../assets/images/sample-add-product-img.jpg";
import "react-dual-listbox/lib/react-dual-listbox.css";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { getCategories } from "slices/thunks";
import MediaUploader from "Components/Common/MediaUploader";
import { JSX } from "react/jsx-runtime";
import { FormikTouched, useFormik } from "formik";
import * as Yup from "yup";
import BreadCrumb from "Components/Common/BreadCrumb";
import { toast } from "react-toastify";
import ImageViewer from "Components/Common/ImageViewer";
import pdfImage from "../../../../assets/images/pdf.png"

type BrandOption = {
  label: string;
  value: string;
  __isNew__?: boolean;
};

const BrandDetailForm = () => {
  const navigate = useNavigate();
  const [socialMediaLinks, setSocialMediaLinks] = useState<string[]>([""]);
  const [brandName, setBrandName] = useState<BrandOption | null>(null);
  const [relation, setRelation] = useState("");
  const [trademarkNumber] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>("");
  const [selectedRadio, setSelectedRadio] = useState("");
  const urlSchema = Yup.string().url("Invalid URL");
  

  const Selectbrand = createSelector(
    (state: any) => state.Brands,
    (brands) => brands?.brands
  );
const brandCategories = useSelector((state: any) => {
  const cat = state?.Brands?.brandCategory;
  return Array.isArray(cat) ? cat : cat?.data || [];
});


  const categoryOptions = Array.isArray(brandCategories)
  ? brandCategories.map((category: any) => ({
    value: category?._id,
    label: category?.name,
  }))
  : [];

  const brand = useSelector(Selectbrand);
  const brandNames = brand.map((item: any) => item?.name);
  const dispatch = useDispatch<any>();
  const [searchField, setSearchField] = React.useState<any>("");
  const [selectedBrandImage, setSelectedImageBrand] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [date, setDate] = useState("");
  const [today] = useState(() => {
    const date = new Date();
    return date.toISOString().split("T")[0];
  });


  const openViewer = (imageUrl: string) => {
    setCurrentImage(imageUrl);
    setViewerOpen(true);
  };

  const closeViewer = () => {
    setViewerOpen(false);
  };

  const handleAddLink = () => {
    setSocialMediaLinks((prevLinks) => [...prevLinks, ""]);
  };

  const handleRemoveLink = (index: number) => {
    setSocialMediaLinks((prevLinks) => prevLinks.filter((_, i) => i !== index));
  };

  const handleChangeLink = (index: number, value: string) => {
    setSocialMediaLinks((prevLinks) =>
      prevLinks.map((link, i) => (i === index ? value : link))
    );
  };

  const handleRelationChange = (e: any) => {
    setRelation(e.target.id);
  };

  useEffect(() => {
    dispatch(getBrandThunk());
    dispatch(getBrandCategory());
  }, [dispatch]);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!relation) {
      return toast.error("Please select relation", { autoClose: 800 });
    }
    if (!brandName) {
      return toast.error("Please select a brand name", { autoClose: 800 });
    }
    if (!trademarkNumber) {
      return toast.error("Please select a trade mark Number", {
        autoClose: 800,
      });
    }
    if (!selectedCategoryId) {
      return toast.error("Please select a brand category", { autoClose: 800 });
    }
    if (socialMediaLinks.length === 0) {
      return toast.error("Please add at least one social media link", {
        autoClose: 800,
      });
    }
    if (!selectedBrandImage) {
      return toast.error("Please upload a brand authentication document", {
        autoClose: 800,
      });
    }
    console.log(brandName);
    const submittedData = {
      brandId: brandName?.value || "",
      brandName: brandName ? brandName.value : "",
      relation: relation,
      trademarkNumber: trademarkNumber,
      socialMediaLinks: socialMediaLinks || [],
      brandAuthenticationDocument: selectedBrandImage,
      brandCategoryId: selectedCategoryId || null,
    };
    setIsLoading(true);
    dispatch(createBrand(submittedData, navigate));
    setIsLoading(false);
    toast.success("Brand Added Successfully", { autoClose: 1000 });
  };

  const handleSelectGroups2 = (selectedOption: any) => {
    if (selectedOption && selectedOption.__isNew__) {
      setBrandName({ label: selectedOption.label, value: "" });
    } else {
      setBrandName(selectedOption);
    }
  };

  const handleStartDateChange = (event: any) => {
    const dateValue = event.target.value;
    formik.setFieldValue("startDate", dateValue);
  };

  const handleEndDateChange = (event: any) => {
    const dateValue = event.target.value;
    formik.setFieldValue("endDate", dateValue);
  };

  const customStyles = {
    dropdownIndicator: () => ({
      display: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };
  const brandOptions = brand.map((item: { name: string; _id: string }) => ({
    label: item.name,
    value: item._id,
  }));

  const placeholderText =
    "Enter a new Brand or Apply Against Existing Brand. This will be your brand identity";

  const validationSchema = Yup.object({
    brandName: Yup.string().required("Brand Name is required"),
    // trademarkNumber: Yup.string().required("Trademark Number is required"),
    relation: Yup.string().required("Relation is required"),
    brandAuthenticationDocument: Yup.string().required(
      "Brand Authentication Document Image is required"
    ),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),

  });

  const validationSchemaOwner = Yup.object({
    brandName: Yup.string().required("Brand Name is required"),
    trademarkNumber: Yup.string()
      .required("Trademark Number is required"),
    relation: Yup.string().required("Relation is required"),
    brandAuthenticationDocument: Yup.string().required("Brand Authentication Document is required"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),

  });

  const dynamicValidationSchema = Yup.lazy((values) =>
    values.relation === "owner" ? validationSchemaOwner : validationSchema
  );

  const formik = useFormik({
    initialValues: {
      brandName: "",
      relation: "",
      trademarkNumber: "",
      startDate: "",
      endDate: "",
      socialMediaLinks: [""],
      brandAuthenticationDocument: "",
      brandCategoryId: "",
    },

    validationSchema: dynamicValidationSchema,
    onSubmit: async (values) => {
      const submittedData = {
        brandId: brandName?.__isNew__ ? "" : brandName?.value,
        brandName: brandName?.label || "",
        relation: values.relation,
        startDate: values.startDate,
        endDate: values.endDate,
        trademarkNumber: values.trademarkNumber,
        socialMediaLinks: values.socialMediaLinks.filter((link) => link.trim() !== ""),
        brandAuthenticationDocument: selectedBrandImage,
        brandCategoryId: values.brandCategoryId,
      };
      console.log(brandName, "check");
      console.log(submittedData, "Final Submitted Data");
      try {
        setIsLoading(true);
        const response = await dispatch(createBrand(submittedData, navigate));
        if (response) {
          console.log("Brand created successfully:", response);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error creating brand:", error);
      }
    },
  });

  console.log(relation)


  const onMediaUpdate = (key: string, value: Media | any) => {
    console.log(key, value);
    let url: string | undefined;
    let media: Media | undefined;

    if (Array.isArray(value)) {
      url = value[0]?.url;
      media = value[0];
    } else {
      url = value?.url;
      media = value;
    }

    if (key === "selectedBrandImage") {
      setSelectedImageBrand(value);
      if (url) {
        formik.setFieldValue("brandAuthenticationDocument", url);
      } else {
        formik.setFieldValue("brandAuthenticationDocument", "");
      }
    }
  };
  const getCustomInput = (testingId: string) => {
  return (props: any) => (
    <components.Input {...props} data-testing-id={testingId} />
  );
};
  const getNameInput = (testingId: string) => {
  return (props: any) => (
    <components.Input {...props} data-testing-id={testingId} />
  );
};

// const categoryInput = getCustomInput("brandcategory_input");

const catNamenput = getCustomInput("Namecategory_input");


//   const getCustomInput = (testingId: string) => {
//   return (props: any) => (
//     <components.Input {...props} data-testing-id={testingId} />
//   );
// };
   
const  categoryInput = getCustomInput("brandcategory_input");
const BrandNameInput = getCustomInput("brandName_Input");

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={"Add Brand"}
          pageTitle="Brands"
          pageTitleRoute="/manage-brands"
        />

        <h4 className="mb-4">Verify Brand Information</h4>

        <Form onSubmit={formik.handleSubmit} className="Brand-Form-Ui-Change">
          <div className="mb-3 " >
            <Label htmlFor="choices-single-no-search">
              Brand Name <span className="text-danger">*</span>
            </Label>
          <div data-testing-Id="brandNme_brandInfo">
          <CreatableSelect<BrandOption>
              isClearable={true}
              placeholder={placeholderText}                                         
              value={
                brandName
                  ? { label: brandName.label, value: brandName.value }
                  : null
              }
              onChange={(selectedOption) => {
                console.log("Selected or New Brand:", selectedOption);

                if (selectedOption) {
                  if ((selectedOption as BrandOption).__isNew__) {
                    formik.setFieldValue("brandName", selectedOption.value);
                    setBrandName({
                      label: selectedOption.label,
                      value: selectedOption.value,
                      __isNew__: true,
                    });
                  } else {
                    // If it's an existing brand, just update the field
                    formik.setFieldValue("brandName", selectedOption.value);
                    setBrandName({
                      label: selectedOption.label,
                      value: selectedOption.value,
                      __isNew__: false,
                    });
                  }
                } else {
                  // If no brand is selected, reset the field
                  formik.setFieldValue("brandName", "");
                  setBrandName(null);
                }
              }}
              options={brandOptions} // The list of available brand options
              styles={customStyles} // Custom styles for the select input
              onBlur={() => formik.setFieldTouched("brandName", true)}
               components={{ Input: categoryInput }}          
               />
            {formik.touched.brandName && formik.errors.brandName && (
              <div className="text-danger">{formik.errors.brandName}</div>
            )}
          </div>
          </div>
          <FormGroup >
            <Label htmlFor="category">
              Brand Category <span className="text-danger">*</span>
            </Label>
          <div data-testing-id="selectCategory_BarndDetail">
          <Select
              id="category"
              placeholder="Select Category"
              className="form-select pt-0 ps-0 pb-0"
              data-testing-Id="brandcategory_brandInfo"
              
              components={{ Input: categoryInput }}
              value={
                categoryOptions.find(
                  (option: { value: string }) =>
                    option.value === formik.values.brandCategoryId
                ) || null
              }
              onChange={(selectedOption: { value: any }) =>
                formik.setFieldValue(
                  "brandCategoryId",
                  selectedOption ? selectedOption.value : ""
                )
              }
              options={categoryOptions}
              styles={customStyles}
              onBlur={() => formik.setFieldTouched("brandCategoryId", true)}
              // components={{ Input: categoryInput }}
            />
            {formik.touched.brandCategoryId &&
              formik.errors.brandCategoryId && (
                <div className="text-danger">{formik.errors.brandName}</div>
              )}
          </div>
          </FormGroup>
          <FormGroup>
            {formik.values.relation === "owner" && (
              <div className="mb-3">
                <FormGroup className="mb-0">
                  <Label>
                    Trademark Number <span className="text-danger">*</span>{" "}
                  </Label>
                  <Input
                    type="text"
                    name="trademarkNumber"
                    id="trademarkNumber"
                    data-testing-Id="tradmark_brandInfo"
                    checked={
                      formik.values.trademarkNumber === "trademarkNumber"
                    }
                    onChange={(e: any) => {
                      formik.setFieldValue("trademarkNumber", e.target.value);
                    }}
                  />
                  {formik.touched.trademarkNumber &&
                    formik.errors.trademarkNumber && (
                      <div className="text-danger">
                        {formik.errors.trademarkNumber}
                      </div>
                    )}
                </FormGroup>
              </div>
            )}
            <Label>
              <strong>
                Relationship with the Brand{" "}
                <span className="text-danger">*</span>
              </strong>
            </Label>
            <div>
              <FormGroup check inline>
                <Input
                  type="radio"
                  name="relation"
                  id="owner"
                  value="owner"
                  checked={formik.values.relation === "owner"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  data-testing-Id="brandOwner_brandInfo"
                />
                <Label check for="owner">
                  Brand Owner
                </Label>
              </FormGroup>
              <FormGroup check inline>
                <Input
                  type="radio"
                  name="relation"
                  id="Exclusive Distributor"
                  value="Exclusive Distributor"
                  data-testing-Id="Exclusive_brandInfo"
                  checked={formik.values.relation === "Exclusive Distributor"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <Label check for="Exclusive Distributor">
                  Exclusive Distributor
                </Label>
              </FormGroup>
              <FormGroup check inline>
                <Input
                  type="radio"
                  name="relation"
                  id="Non-Exclusive Distributor"
                  value="Non-Exclusive Distributor"
                  checked={formik.values.relation === "Non-Exclusive Distributor"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  data-testing-Id="Distributor_brandInfo"
                />
                <Label check for="Non-Exclusive Distributor">
                  Non-Exclusive Distributor
                </Label>
              </FormGroup>
              <FormGroup check inline>
                <Input
                  type="radio"
                  name="relation"
                  id="reseller"
                  value="reseller"
                  checked={formik.values.relation === "reseller"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  data-testing-Id="Reseller_brandInfo"
                />
                <Label check for="reseller">
                  Reseller
                </Label>
              </FormGroup>
            </div>
            {formik.touched.relation && formik.errors.relation && (
              <div className="text-danger">{formik.errors.relation}</div>
            )}
          </FormGroup>

          <FormGroup>
            <div className="d-flex flex-direction-row gap-4">
              <div>
                <Label>Start Date<span className="text-danger">*</span></Label>
                <Input
                  type="date"
                  name="startDate"
                  value={formik.values.startDate}
                  min={today}
                  onChange={handleStartDateChange}
                  data-testing-Id="startDate_brandInfo"
                />
                {formik.touched.startDate && formik.errors.startDate && (
                  <div className="text-danger">{formik.errors.startDate}</div>
                )}
              </div>

              <div>
                <Label>End Date<span className="text-danger">*</span></Label>
                <Input
                  type="date"
                  name="endDate"
                  value={formik.values.endDate}
                  min={formik.values.startDate || today}
                  onChange={handleEndDateChange}
                  data-testing-Id="endDate_brandInfo"
                />
                {formik.touched.endDate && formik.errors.endDate && (
                  <div className="text-danger">{formik.errors.endDate}</div>
                )}
              </div>

            </div>
          </FormGroup>
          <FormGroup>
            <Label>
              <strong>
                Authentication Documents <span className="text-danger">*</span>{" "}
              </strong>
            </Label>
            <Row>
              <Col md={4}>
             
                <MediaUploader
                  onMediaUpdate={(value: any) =>
                    onMediaUpdate('selectedBrandImage', value)
                  }
                  isMultiple={false}
                  initialMedia={selectedBrandImage}
                  title="Upload Authentication Documents"
                  isRequired={true}
                  dataTestingId={"uploader_brandInfo"}
                  allowPdf={true} 
                />
                {formik.touched.brandAuthenticationDocument &&
                  formik.errors.brandAuthenticationDocument && (
                    <div className="text-danger">
                      {formik.errors.brandAuthenticationDocument}
                    </div>
                  )}
              </Col>
            </Row>
          </FormGroup>

          <FormGroup>
            <Label>
              <strong>Social Media Links</strong>
            </Label>
            <p className="text-muted">
              Please provide the URL to your brand's official website or social
              media profile.
            </p>
            {/* {(formik.values.socialMediaLinks.filter((link) => link.trim() !== "")).length === 0 && (
              <Button
                color="success"
                onClick={() => formik.setFieldValue("socialMediaLinks", [""])}
              >
                Add Link
              </Button>
            )} */}

            {formik.values.socialMediaLinks.map((link, index) => (
              <Row className="mb-2" key={index}>
                <Col md={10}>
                  <Input
                    type="text"
                    placeholder="Enter Social Media Link"
                    data-testing-Id={"social_brandInfo" + index}
                    value={link}
                    onChange={(e) => {
                      const newLinks = [...formik.values.socialMediaLinks];
                      newLinks[index] = e.target.value;
                      formik.setFieldValue("socialMediaLinks", newLinks);
                    }}
                    onBlur={() =>
                      formik.setFieldTouched(`socialMediaLinks[${index}]`, true)
                    }
                  />
                </Col>
                <Col md={2} className="d-flex align-items-center">
                  {/* Disable the "-" button if there's only one link */}
                  <Button
                    color="danger"
                    data-testing-Id={"close_brandInfo" + index}
                    onClick={() => {
                      if (formik.values.socialMediaLinks.length > 1) {
                        const newLinks = formik.values.socialMediaLinks.filter(
                          (_, i) => i !== index
                        );
                        formik.setFieldValue("socialMediaLinks", newLinks);
                        toast.success("Link removed successfully!" ,  { autoClose: 1500 });
                      }
                    }}
                    style={{ marginRight: "10px" }}
                    disabled={formik.values.socialMediaLinks.length <= 1} // Disable if only one link
                  >
                    -
                  </Button>
                  {index === formik.values.socialMediaLinks.length - 1 && (
                    <Button
                      color="success"
                      data-testing-Id="plus_brandInfo"
                      onClick={() => {
                        const newLinks = [...formik.values.socialMediaLinks];
                        const lastLink = newLinks[newLinks.length - 1]?.trim();
                        const urlPattern = /^(https?:\/\/)?([\w\-]+\.)+[a-z]{2,}(\/\S*)?$/i;
                        if (lastLink === "") return;
                        if (!urlPattern.test(lastLink)) {
                        toast.error("Please enter a valid URL before adding a new one.", {
                          autoClose: 1500,
                        });
                        return;
                        }
                          newLinks.push("");
                          formik.setFieldValue("socialMediaLinks", newLinks);
                          toast.success("Link Added successfully!", { autoClose: 1500 });
                      }}
                    >
                      +
                    </Button>
                  )}
                </Col>
              </Row>
            ))}



          </FormGroup>

          <Button
            type="submit"
            data-testing-Id="confirm_brandInfo"
            // onClick={() => {
            // console.log("🛠️ Button Clicked");
            // console.log("Formik Errors:", formik.errors);
            // console.log("Formik Touched Fields:", formik.touched);
            // formik.handleSubmit();
            // }}
            className={`btn w-sm btn-primary ${isLoading ? "disabled" : ""}`}
            disabled={isLoading}
          >
             {isLoading ? (
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : (
              "Confirm"
            )}
          </Button>
        </Form>
      </Container>
    </div>
  );
};

export default BrandDetailForm;
